module.exports = __webpack_public_path__ + "img/denglu_logo.8761ecbc.png";